import { render, staticRenderFns } from "./penjualanpostingar.vue?vue&type=template&id=c72b98f8"
import script from "./penjualanpostingar.vue?vue&type=script&lang=js"
export * from "./penjualanpostingar.vue?vue&type=script&lang=js"
import style0 from "./penjualanpostingar.vue?vue&type=style&index=0&id=c72b98f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports